import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

import { navData } from "data/nav";

const Nav = ({ isBorderless }) => {
  return (
    <nav
      className={clsx(
        "header-desktop-nav",
        isBorderless && "header-desktop-nav--borderless"
      )}
    >
      {navData.map((item, index) => (
        <Link key={index} to={item.url}>
          {item.label}
        </Link>
      ))}
    </nav>
  );
};

export default Nav;
